import { render, staticRenderFns } from "./DirectOrders.vue?vue&type=template&id=eb340ec6&scoped=true"
import script from "./DirectOrders.vue?vue&type=script&lang=js"
export * from "./DirectOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb340ec6",
  null
  
)

export default component.exports